// @ts-check
// BlockCondition class and decorator
export { BlockCondition } from "./condition";
export { blockCondition } from "./decorator";

// Built-in condition classes
// Registered by the freeze-block-registry initializer
export { default as BlockOutletArgCondition } from "./outlet-arg";
export { default as BlockRouteCondition } from "./route";
export { default as BlockUserCondition } from "./user";
export { default as BlockSettingCondition } from "./setting";
export { default as BlockViewportCondition } from "./viewport";
